import { createLogger } from '@/lib/logger';

document.addEventListener('DOMContentLoaded', () => {
  const log = createLogger('sticky-category-bar');
  const stickyCategoryBar = document.querySelector<HTMLElement>(
    '.sticky-categories-bar--outer-wrapper',
  );

  if (!stickyCategoryBar) {
    log.warn('StickyCategoryBar: sticky category bar element not found');
    return;
  }

  const scrollThresholdElementSelector = stickyCategoryBar.dataset.scrollThresholdElement;

  if (!scrollThresholdElementSelector) {
    log.warn('StickyCategoryBar: scroll threshold element selector not found');
    return;
  }

  const scrollThresholdElement = document.querySelector(scrollThresholdElementSelector);

  if (!scrollThresholdElement) {
    log.warn('StickyCategoryBar: scroll threshold element not found');
    return;
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          stickyCategoryBar.classList.remove('visible');
        } else {
          stickyCategoryBar.classList.add('visible');
        }
      });
    },
    {
      threshold: [0, 1],
    },
  );

  observer.observe(scrollThresholdElement);
});
